import './footer.styles.scss';

export default function Footer() {
  return (
    <footer className="container footer">
      With &lt;3 by fran
    </footer>
  )
}
